import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";

interface TableProps
  extends HTMLAttributes<HTMLTableElement>,
    CommonComponentProps {}

export function Table({ children, className, ...rest }: TableProps) {
  return (
    <table className={cx("w-full", className)} {...rest}>
      {children}
    </table>
  );
}

interface THeadProps
  extends HTMLAttributes<HTMLTableSectionElement>,
    CommonComponentProps {}

export function THead({ children, className, ...rest }: THeadProps) {
  return (
    <thead className={className} {...rest}>
      {children}
    </thead>
  );
}

interface TBodyProps
  extends HTMLAttributes<HTMLTableSectionElement>,
    CommonComponentProps {}

export function TBody({ children, className, ...rest }: TBodyProps) {
  return (
    <tbody className={className} {...rest}>
      {children}
    </tbody>
  );
}

interface TRowProps
  extends HTMLAttributes<HTMLTableRowElement>,
    CommonComponentProps {}

export function TRow({ children, className, ...rest }: TRowProps) {
  return (
    <tr className={cx("m-0 border-t p-0 even:bg-muted", className)} {...rest}>
      {children}
    </tr>
  );
}

interface THProps
  extends HTMLAttributes<HTMLTableCellElement>,
    CommonComponentProps {}

export function TH({ children, className, ...rest }: THProps) {
  return (
    <th
      className={cx(
        "border px-4 py-2 text-left font-bold [&[align=center]]:text-center [&[align=right]]:text-right",
        className
      )}
      {...rest}
    >
      {children}
    </th>
  );
}

interface TDProps
  extends HTMLAttributes<HTMLTableCellElement>,
    CommonComponentProps {}

export function TD({ children, className, ...rest }: TDProps) {
  return (
    <td
      className={cx(
        "border px-4 py-2 text-left [&[align=center]]:text-center [&[align=right]]:text-right",
        className
      )}
      {...rest}
    >
      {children}
    </td>
  );
}
